import type { BreadcrumbList } from "@decocms/apps-commerce/types";
import { sanitizeStoreUrl } from "~/utils/constants";

interface Props {
  itemListElement: BreadcrumbList["itemListElement"];
  page: "search" | "product";
}

const PAGE_SPECIFIC_CSS = {
  search:
    "text-[11px] lg:text-[13px] leading-[11px] text-[#1A1A1A] font-normal underline",
  product:
    "text-[11px] lg:text-[13px] leading-[11px] text-[#1A1A1A] font-normal underline",
};

function Breadcrumb({ itemListElement = [], page }: Props) {
  const items = [{ name: "Home", item: "/" }, ...itemListElement];

  return (
    <div className="breadcrumbs p-0 md:py-2">
      <ul>
        {items
          .filter(({ name, item }) => name && item)
          .map(({ name, item }) => (
            <li key={item}>
              <a
                href={sanitizeStoreUrl(item)}
                className={`font-['Poppins',Helvetica,Arial,sans-serif]  ${
                  PAGE_SPECIFIC_CSS[page]
                }`}
              >
                {name}
              </a>
            </li>
          ))}
      </ul>
    </div>
  );
}

export default Breadcrumb;
